export default __webpack_public_path__ + "static/media/G_wdt_c_cap_3.5790eba1.mp3";